import React from 'react';

// ux
import ModalCompareItem from '../ux/ModalCompareItem';

const CompareModal = ({ modalInfo, fetchFuse, handleCloseModal }) => {
  return (
    <div className="compare-modal-content">
      <div className="compare-modal-header">
        <div className="header-left">
          <h3>Typical Monthly Mentions</h3>
        </div>
        <div className="fuse-header">
          <h2>Fusion</h2>
          <div className="fusion-labels">
            <h3>Media Mentions</h3>
            <h3>Media Reach</h3>
            <h3>Frequency</h3>
            <h3>Ignition Thrust</h3>
          </div>
        </div>
      </div>
      <div className="compare-modal-body">
        {modalInfo.map((fuse, index) => (
          <ModalCompareItem
            key={index}
            fuse={fuse}
            fetchFuse={fetchFuse}
            handleCloseModal={handleCloseModal}
          />
        ))}
      </div>
    </div>
  );
};

export default CompareModal;
